import { CommonInputProps, InputLabel } from './common';
import { Horizontal } from 'packages/radiant-react/layout';
import styles from './styles.module.scss';
import { Typography } from 'packages/radiant-react/typography';

export const TextTransformInput = ({ value, onChange, name, info }: CommonInputProps) => {
  return (
    <Horizontal className={styles.transformInput}>
      <InputLabel name={name} info={info} />
      <Horizontal className={styles.transformInputActions}>
        <Typography
          variant="body-normal"
          onClick={() => onChange('uppercase')}
          className={`${styles.transformInputAction} ${
            value === 'uppercase' ? styles.selected : ''
          }`}
        >
          AA
        </Typography>
        <Typography
          variant="body-normal"
          onClick={() => onChange('lowercase')}
          className={`${styles.transformInputAction} ${
            value === 'lowercase' ? styles.selected : ''
          }`}
        >
          aa
        </Typography>
        <Typography
          variant="body-normal"
          onClick={() => onChange('capitalize')}
          className={`${styles.transformInputAction} ${
            value === 'capitalize' ? styles.selected : ''
          }`}
        >
          Aa
        </Typography>
      </Horizontal>
    </Horizontal>
  );
};
